






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class Overlay extends Vue {
  @Prop()
  loading: boolean

}
